import { motion } from "framer-motion";
import placement from "../../assets/place_gif.mp4";
import icon1 from "../../assets/icon1.png";
import icon2 from "../../assets/icon2.png";
import icon3 from "../../assets/icon3.png";
import icon4 from "../../assets/icon4.png";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function Copr_gif() {
  const theme = useTheme();

  const isSm = useMediaQuery(theme.breakpoints.down("sm")); // <600px
  const isMd = useMediaQuery(theme.breakpoints.down("md")); // <900px

  const cardData = [
    {
      icon: icon1,
      text: "Pre-trained candidates, saving\n3–6 months of onboarding",
    },
    {
      icon: icon2,
      text: "AI + human-vetted for technical +\nsoft skills",
    },
    {
      icon: icon3,
      text: "Custom upskilling to match your\ntech stack or processes",
    },
    {
      icon: icon4,
      text: "Employer branding boost via our\nelite talent network",
    },
  ];

  const headingFontSize = isSm ? "22px" : isMd ? "28px" : "40px";
  const iconSize = isSm ? "32px" : "48px";
  const cardBoxSize = isSm ? "70px" : "110px";
  const cardPadding = isSm ? "12px" : "20px";
  const fontSize = isSm ? "13px" : "15px";
  const gapSize = isSm ? "16px" : "40px";
  const videoBorderRadius = isSm ? "14px" : "36px";

  return (
    <div>
    <div
      style={{
        width: "100%",
        overflowX: "hidden",
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
      }}
    >
      {/* Heading */}
      <div
        style={{
          fontFamily: "Montserrat",
          fontWeight: 700,
          color: "#0D5EF4",
          fontSize: headingFontSize,
          textAlign: "center",
          margin: "30px 0",
          padding: "0 10px",
        }}
      >
        Why Choose NextGen Placement?
      </div>

      {/* Cards */}
      <div
        style={{
          width: "100%",
          backgroundColor: "#F0F4F9",
          padding: isSm ? "20px 10px" : "50px 20px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: gapSize,
            maxWidth: "1200px",
            margin: "0 auto",
            boxSizing: "border-box",
          }}
        >
          {cardData.map((card, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 60, scale: 0.9 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 0.6, delay: index * 0.2, ease: "easeOut" }}
              viewport={{ once: false, amount: 0.4 }}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                width: "100%",
                maxWidth: "240px",
              }}
            >
              <div
                style={{
                  background: "#fff",
                  borderRadius: "16px",
                  padding: cardPadding,
                  width: cardBoxSize,
                  height: cardBoxSize,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  marginBottom: "12px",
                  boxSizing: "border-box",
                }}
              >
                <img
                  src={card.icon}
                  alt="icon"
                  style={{
                    height: iconSize,
                    maxWidth: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
              <p
                style={{
                  width:'300px',
                  color: "#6B7280",
                  fontSize: fontSize,
                  whiteSpace: "pre-line",
                  lineHeight: "1.4",
                  padding: "0 10px",
                  boxSizing: "border-box",
                }}
              >
                {card.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Video Section */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "40px 10px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            fontFamily: "Montserrat",
            fontWeight: 700,
            fontSize: headingFontSize,
            textAlign: "center",
            marginBottom: "30px",
            padding: "0 10px",
          }}
        >
          Our Campus Hiring Overview
        </div>

        <motion.video
          src={placement}
          autoPlay
          loop
          muted
          playsInline
          style={{
            width: "100%",
            maxWidth: "100%",
            marginBottom: "30px",
            borderRadius: videoBorderRadius,
            objectFit: "cover",
            boxShadow: "0px 0px 0px rgba(0, 0, 0, 0)",
          }}
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            boxShadow: "0px 20px 50px rgba(0, 0, 0, 0.3)",
          }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.5 }}
        />
      </div>
    </div>
    </div>
  );
}
